const routes = [
    {
        path: "/airport/transfer/request",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'housingrequest_airporttransferlist'
        }
    }
];

export default routes;
